import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {GroupModel} from "../../models/group.model";

export class GroupsMultiSelectComponent implements IController {

  selectedIds: any;
  options: any;
  optionIds: string[];
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  onChange: Function;

  private groupsRef: any;
  public selectedGroups: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $groups, private $element) {
    this.groupsRef = this.$groups();
  }

  $onInit() {
    this._setSelectedGroups();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedGroups();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'groups';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        if (!selectedIds?.length) {
          this.onChange({groups: [], selectedIds: []});
          panel.destroy();
        } else {
          if (!!this.options) {
            const groups = _.filter(this.options, (o) => {
              return _.includes(selectedIds, o.id);
            });
            this.onChange({groups: groups, selectedIds: selectedIds});
            panel.destroy();
          } else {
            this.groupsRef.$asyncValues(selectedIds)
              .then((groups: GroupModel[]) => {
                this.onChange({groups: groups, selectedIds: selectedIds});
                panel.destroy();
              });
          }
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedIds: []});
  }

  private _setSelectedGroups() {
    if (!!this.selectedIds?.length) {
      if (!!this.options) {
        this.selectedGroups = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      } else {
        this.groupsRef.$asyncValues(this.selectedIds)
          .then((groups: GroupModel[]) => {
            this.selectedGroups = _.orderBy(groups, ['name'], ['asc']);
            this._setSelectedText();
          })
      }
    } else {
      this.selectedGroups = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedGroups, (b, i) => {
      string += b.name;
      if ((i + 1) < this.selectedGroups.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedGroups[0].name;
      if(this.selectedGroups.length - 1) {
        string += ` +${this.selectedGroups.length - 1}`
      }
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.groups')
  .component('groupsMultiSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedIds: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./groups-multi-select.html').default,
    controller: GroupsMultiSelectComponent
  });
